import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMenuService, DwMessage, DwMessageSeverity, DwRoutingService, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, FlightSchoolOrganizationEntity } from '../../../../meta-data/app-meta-data.service';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { ActivatedRoute, Router } from '@angular/router';

@DwComponent({
  key: 'school-public-profile',
  name: 'School Public Profile',
  componentType: DwComponentType.pageComponent,
  //parentItemName: AppMetaDataItemNames.PilotExaminer,
  isGlobal: true,
})
@Component({
  selector: 'app-school-public-profile',
  templateUrl: './school-public-profile.component.html',
  styleUrls: ['./school-public-profile.component.scss']
})
export class SchoolPublicProfileComponent implements OnInit {
  schoolKey: any;
  keyValue: number;
  flightSchoolOrganization: FlightSchoolOrganizationEntity;
  showNotFound = false;
  checkrideTypes: string[];
  airports: string[];

  portalClass?: string;
  showFullScreen = false;

  constructor(private menuService: DwMenuService, private router: Router, private route: ActivatedRoute, private dwRoutingService: DwRoutingService, private schoolRepository: SchoolRepositoryService) { }

  ngOnInit(): void {
    this.menuService.menuStateObservable.subscribe((menuState) => {
      // console.log(menuState);
      this.setupComponent();
      this.setupLastApplicant();
    });

    this.setupComponent();
  }


  initComplete = false;
  private setupComponent() {
    
    

    if (this.initComplete) {
      return;
    }


    const params = this.route.snapshot.paramMap;

    this.schoolKey = params.get('schoolKey');

    if (!this.schoolKey) {

      this.schoolKey = this.menuService.getMenuParam('schoolKey');

      if (!this.schoolKey) {

        this.flightSchoolOrganization = this.schoolRepository.getCurrentPublicFlightSchool();
        return;
      }
    }

    if (getParameterByName(this.router, 'fullscreen')) {
      this.showFullScreen = true;
      this.portalClass = 'full-screen-portal';
    }

    this.initComplete = true;

    this.schoolRepository.getFlightSchoolByProfileKey(this.schoolKey)
      .subscribe((flightSchoolOrganization) => {

        this.setupFlightSchool(flightSchoolOrganization);
      });
  }

  private setupLastApplicant() {
    const lastApplicant = this.schoolRepository.getLastApplicant();

    if (lastApplicant) {
      // Clear out the last applicant so it doesn't keep getting reused
      this.schoolRepository.storeLastApplicant(null);

      this.message = {
        severity: DwMessageSeverity.success,
        messageBody: `Applicant ${lastApplicant.ApplicantName} has been submitted successfully.`,
        allowClose: true,
        timeToShow: 10000
      }
    }
  }

  message: DwMessage;

  setupFlightSchool(flightSchoolOrganization: FlightSchoolOrganizationEntity) {
    this.flightSchoolOrganization = flightSchoolOrganization;

    this.schoolRepository.storeCurrentPublicFlightSchool(flightSchoolOrganization);

    if (!this.flightSchoolOrganization || !this.flightSchoolOrganization.PublicPortalIsActive) {
      this.showNotFound = true;
      return;
    }
  }

  addStudent() {
     const url = `/school-portal/${this.flightSchoolOrganization?.PublicPortalSlug}/submit-request`;

    this.dwRoutingService.navigateToUrl(url);

    //this.router.navigate([`/school-portal/${this.schoolKey}/submit-request`], { queryParams: { schoolKey: this.schoolKey } });
  }

}
